import React, { useEffect, useState } from "react";
import ApiCalls from "../../../apis/api-calls";
import SideNav, { NavItem, NavText } from "@trendmicro/react-sidenav";
import { inject, observer } from "mobx-react";
import CreditView from "../CreditViewComponent";
import Utility from "../../../../common/utility";
import config from "../../../../config/config";
import { Document, Page, pdfjs } from 'react-pdf';
import styled from "styled-components";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import "../../../../assets/css/components/Profile/BillingComponent/BillingComponent.css";
import moment from "moment";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const StyledSideNav = styled(SideNav)`
  display: block;
  background-image: linear-gradient(white 3.5%, #eff5fb 10%) !important;
  position: sticky !important;
  width: auto;
  overflow: auto;
  border-radius: 0 0 0 5px;
  border-bottom: 1px solid #fff;
  z-index: 1;
`;
StyledSideNav.defaultProps = SideNav.defaultProps;

const StyledNavItem = styled(NavItem)`
  background-color: #eff5fb !important;
  border: 1px solid #fff;
  border-right: 1px solid #eff5fb;
  border-left: 1px solid #eff5fb;
  height: 70px;
  &.sidenav---selected---1EK3y {
    background-color: #fff !important;
    border: 1px solid #eff5fb;
    border-left: 5px solid #0165b9;
    & div {
      color: #0165b9 !important;
      margin-left: 2px;
    }
    & :first-child {
      margin-left: 2px !important;
      font-weight: normal !important;
    }
    & :last-child {
      margin-left: 2px !important;
      font-weight: normal !important;
    }
  }
`;
StyledNavItem.defaultProps = NavItem.defaultProps;

const InvoiceList = inject("sharedStore")(
  observer((props) => {
    const { showCreditModal } = props
    const { userRole, invoicesData, username, updatePdfFile,selectedInvoice } = props.sharedStore
    let fullName = username;
    var index = invoicesData.findIndex(p => {
      return p.invoice_no === selectedInvoice.invoice_no
    })  
    let nameEnding = "...";
    if (fullName.length > 18) fullName = fullName.substring(0, 18) + nameEnding;
    
    if (invoicesData && invoicesData.length > 0) {
      return (
        invoicesData &&
        invoicesData.map((invoice, i) => {
          let dueAmount =
            invoice.is_paid === 1 || invoice.is_paid === 2
              ? 0
              : invoice.open_balance != null
                ? invoice.open_balance
                : invoice.balance_due;
          return (
            <StyledNavItem
              active={i===index ? true:false}
              key={i + 1}
              id={(i + 1).toString()}
              eventKey={(i + 1).toString()}
              onClick={() => updatePdfFile(invoice)}
            >
              <NavText id="invoiceNavText">
                <div className="invoiceFullName">
                  {fullName} <span className="hidespan">demo</span>
                </div>
                <div className="invoiceTotal">
                  ${""}
                  {parseFloat(dueAmount, 10).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })}
                </div>
                <div className="invoiceNumber">
                  INV-{invoice && invoice.invoice_no ? invoice.invoice_no : 0}
                &nbsp;|&nbsp;{moment(invoice.bill_date).format("MM-DD-YYYY")}
                  {userRole === 1 && invoice.credits > 0 ? (
                    <span
                      className="creditLinkBtn"
                      onClick={()=>showCreditModal(invoice)}
                    >
                      CREDIT
                    </span>
                  ) : null}
                </div>
              </NavText>
            </StyledNavItem>
          );
        })
      );
    } else return null;
  }));

const logTabData = () => {
  const data = {
    user_id: Utility.getData("userId"),
    tab_name: "invoice",
  };
  ApiCalls.logTabData(data)
    .then((res) => {
      if (res && res.status_code !== 200) {
        console.log("Error in tab log");
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
};

const InvoiceTab = inject("sharedStore")(
  observer((props) => {
    const { sharedStore } = props;
    const [expanded, setExpanded] = useState(true)
    const [creditModal, toggleCreditModal] = useState(false)
    const [credits, setCredit] = useState([])
    const [numPages, setNumPages] = useState(null)

    useEffect(() => {
      logTabData()
    }, [])


    const showCreditModal = (invoice) => {
      let { pdfId } = sharedStore;
      if (pdfId === invoice.invoice_id) {
        let data = {
          invoice_id: invoice.invoice_id,
        };
        ApiCalls.fetchCredits(data)
          .then((res) => {
            if (res && res.responseCode === 200) {
              setCredit(res.data.result)
              toggleCreditModal(true)
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    };


    const downloadPdf = () => {
      sharedStore.showLoader();
      fetch(
        `${config.baseURL}/backend/fetchInvoice?key=${sharedStore.pdfKey}`
      ).then((response) => {
        sharedStore.hideLoader();
        response &&
          response.blob().then((blob) => {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(
                blob,
                sharedStore.pdfKey.split("/").pop()
              );
            } else {
              let url = window.URL.createObjectURL(blob);

              let a = document.createElement("a");
              a.href = url;
              a.download = sharedStore.pdfKey.split("/").pop();
              a.click();
            }
          });
      }).catch((err) => {
        sharedStore.hideLoader();
      })
    }

    const onToggle = (expanded) => {
      setExpanded(expanded)
    };


    const onDocumentLoadSuccess = ({ numPages }) => {
      setNumPages(numPages)
      sharedStore.hideLoader();
    };

    const hideCreditModal = () => {
      toggleCreditModal(false);
    };



    return (
      <div id="invoiceContainerOuter">
        {sharedStore.invoicesData && sharedStore.invoicesData.length > 0 ? (
          <React.Fragment>
            <StyledSideNav
              id="invoiceSideNav"
              expanded={expanded}
              onToggle={onToggle}
            // onScroll={this.handleScroll}
            >
              {" "}
              <StyledSideNav.Toggle id="invoiceToggleButton" />
              <SideNav.Nav defaultSelected="1">
                
                <InvoiceList showCreditModal={showCreditModal} />
              </SideNav.Nav>
            </StyledSideNav>

            <div className="invoiceContainerInner">
              <div className="invoiceHeader">
                Invoice
                {sharedStore.pdfKey !== "" ? (
                  <button
                    type="button"
                    className={"btn btn-download"}
                    onClick={downloadPdf}
                  >
                    Download PDF
                  </button>
                ) : null}
              </div>
              {sharedStore.pdfKey !== "" ? (
                <div className="invoiceBody">
                  <Document
                    file={sharedStore.file}
                    loading={
                      <div className="loader-wrapper">
                        <div className="customloader">
                          <div className="loader"></div>
                        </div>
                      </div>
                    }
                    onLoadSuccess={onDocumentLoadSuccess}
                    renderMode="svg"
                  >
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        renderMode="svg"
                        scale={1.8}
                      />
                    ))}
                  </Document>
                </div>
              ) : null}
              <div className="invoiceBodyTotal">
                Total Due
                <div>
                  $
                  {parseFloat(sharedStore.payableAmount, 10).toLocaleString("en-US", {
                minimumFractionDigits: 2,
              })}
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
            <div className="invoiceNullBody">
              <div className="invoiceNullMessage">
                You do not have any invoices yet, but be sure to check back when
                it's time to make a payment!
            </div>
            </div>
          )}
        {creditModal ? (
          <CreditView
            modalVisibility={creditModal}
            closeModalHandler={hideCreditModal}
            backdrop={true}
            credits={credits}
          />
        ) : null}
      </div>
    );

  }))

export default InvoiceTab;



// WEBPACK FOOTER //
// ./src/components/Profile/BillingComponent/Tabs/InvoiceTab.jsx